import Checkbox from './Checkbox';
import * as CheckboxStyles from './Checkbox.styles';

export default Checkbox;

export { CheckboxStyles };
